/**
 * 日视图和周视图的时间线
 */

import { size } from "lodash";
import React from "react";
import dayjs from "dayjs";
import "./index.less";

function getTileSplit(hour = 1, minute = 60) {
  const timeSplit = [];
  for (let i = 1; i < 24; i += hour) {
    for (let j = 0; j < 60; j += minute) {
      let time = `${i}:${j === 0 ? "00" : j}`;
      timeSplit.push(time);
    }
  }
  return timeSplit;
}

// eslint-disable-next-line max-params
export default function TimeLine(
  hour = 1,
  minute = 60,
  current = dayjs(),
  currentTimeObj: {
    curtime: dayjs.Dayjs;
    top: number;
  } = {
    curtime: dayjs(),
    top: 0
  }
) {
  const timeSplit = getTileSplit();
  // currentTimeObj.curtime.isBefore(dayjs().hour, 'minute');
  return (
    <div className="calendar-view-timeline">
      <div key={0} className="calendar-view-timeline-firstItem" />
      {timeSplit.map((t) => {
        return (
          <div key={t} className="calendar-view-timeline-item">
            <div className="item-timeLabel">
              {!currentTimeObj.curtime.isBetween(
                dayjs(dayjs().format("YYYY-MM-DD") + " " + t).subtract(16, "minute"),
                dayjs(dayjs().format("YYYY-MM-DD") + " " + t).add(16, "minute"),
                "minute"
              ) || !currentTimeObj.curtime.isSame(current, "day")
                ? t
                : ""}
            </div>
            <div className="item-divider" />
          </div>
        );
      })}
      <div key={24} className="calendar-view-timeline-bottomItem" />
      {currentTimeObj.curtime.isSame(current, "day") && (
        <div
          className="calendar-view-timeline-currenttime"
          style={{
            // 减去文字高度的一半6 居中
            top: currentTimeObj.top - 6 + "px"
          }}
        >
          {currentTimeObj.curtime.format("HH:mm")}
        </div>
      )}
    </div>
  );
}

export function demo() {
  return (
    <div
      style={{
        width: "700px",
        height: "500px",
        overflow: "auto"
      }}
    >
      <div
        style={{
          width: "700px",
          height: "1700px"
        }}
      >
        {TimeLine()}
      </div>
    </div>
  );
}
